import { Grid, Typography } from '@mui/material';
import { Header } from 'components/Header/Header';

export const Terms = () => {
  return (
    <Grid className='bg-black'>
      <Header />
      <Grid>
        <Typography variant='h3' textAlign={'center'}>
          Terms and Conditions
        </Typography>

        <Grid>
          <Typography variant={'body1'} textAlign={'center'}>
            // Todo : add text here
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  ); //TODO External Microservice Dynamic content for the Terms , Configurable from WYSIWIG Editor
};
